const genesysChatParam = "genesys";

export const canRender = (configKey, appConfig, brand, environment) => {
	if (appConfig[configKey].supportedBrands.includes(brand)) {
		if (appConfig[configKey].excludedEnvironments?.includes(environment)) {
			return false;
		}
		return true;
	} else {
		return false;
	}
};

export const isGenesysChatEnabled = () => {
	try {
		const url = new URL(window?.location.href);
		const params = new URLSearchParams(url.search);
		if (params.has(genesysChatParam)) {
			window?.sessionStorage.setItem(
				genesysChatParam,
				params.get(genesysChatParam)
			);
		}
	} catch (error) {
		console.error(error);
	}
	return window?.sessionStorage.getItem(genesysChatParam) === "true";
};

export const isChatEnabledForLocale = (
	configKey,
	appConfig,
	environment,
	locale
) => {
	const chatConfiguration =
		appConfig.environmentConfiguration?.[environment]?.[configKey];
	const supportedLocales = (chatConfiguration.allowedLocales || []).join(
		Object.keys(chatConfiguration.localesConfiguration || {})
	);
	return supportedLocales.includes("*") || supportedLocales.includes(locale);
};

export const canRenderGenesysChat = (
	configKey,
	appConfig,
	brand,
	environment,
	locale
) => {
	if (isGenesysChatEnabled()) return true;
	return (
		canRender(configKey, appConfig, brand, environment) &&
		(!locale ||
			isChatEnabledForLocale(configKey, appConfig, environment, locale))
	);
};
